import { motion, type HTMLMotionProps } from 'motion/react'
import { HOVER_SPRING } from './variants'
import { useHoverCapable } from './useMediaQuery'

export interface PressableProps extends Omit<HTMLMotionProps<'div'>, 'whileHover' | 'whileTap' | 'transition'> {
  children: React.ReactNode
  hoverScale?: number
  tapScale?: number
}

/**
 * Inline wrapper that gives any button or link a hover grow and tap shrink.
 * Wrap the existing <Button> rather than replacing it so styling and `asChild` keep working.
 * The hover grow only applies on hover-capable devices; the tap feedback works everywhere.
 */
export function Pressable({ children, hoverScale = 1.03, tapScale = 0.97, style, ...rest }: PressableProps) {
  const hoverCapable = useHoverCapable()

  return (
    <motion.div
      whileHover={hoverCapable ? { scale: hoverScale } : undefined}
      whileTap={{ scale: tapScale }}
      transition={HOVER_SPRING}
      style={{ display: 'inline-flex', ...style }}
      {...rest}
    >
      {children}
    </motion.div>
  )
}
